import ReactiveWidget from "lib/reactiveWidget";
import numberFormatter from 'number-formatter';
import $ from 'jquery';


class FixturesFilter extends ReactiveWidget  {
  bind() {
    this.form = this.root

    bindFormSubmit.call(this)
    this.hideSpinner()
  }

  showSpinner() {
    this.root.find('.loading-spinner').show()
  }

  hideSpinner() {
    window.delay(() => {
      this.root.find('.loading-spinner').hide()
    }, 500)
  }

  render() {

  }
}

const submitForm = function () {
  let form = this.form

  $.ajax({
    method: form.attr('method'),
    url: form.attr('action'),
    dataType: 'json',
    data: form.serializeArray(),
    beforeSend: (xhr, options) => {
      this.showSpinner()
      xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')
    },
    success: (response) => {
      this.hideSpinner()
      this.renderPartials($('body'), response.partials)
    },
    error: (xhr, text, error) => {
      console.info(error)
      this.hideSpinner()
    }
  });
};

const bindFormSubmit = function() {
  this.root.on('keyup', (e) => {
    window.delay(() => {
      submitForm.call(this)
    }, 500)
  })

  this.root.on('change', "select", (e) => {
    window.delay(() => {
      submitForm.call(this)
    }, 50)
  })
}

export default FixturesFilter
